<template>
  <footer class="landing-footer">
    <div class="footer-container">
      <div class="footer-grid">
        <!-- Brand -->
        <div class="footer-brand">
          <div class="brand-logo">
            <i class="fas fa-graduation-cap" />
            <span>NC OSAS</span>
          </div>
          <p>
            Office of Student Affairs & Services - Dedicated to fostering
            holistic student development and welfare at Northeastern College.
          </p>
          <div class="social-links">
            <a
              href="#"
              aria-label="Facebook"
            >
              <i class="fab fa-facebook-f" />
            </a>
            <a
              href="#"
              aria-label="Twitter"
            >
              <i class="fab fa-twitter" />
            </a>
            <a
              href="#"
              aria-label="Instagram"
            >
              <i class="fab fa-instagram" />
            </a>
          </div>
        </div>

        <!-- Quick Links -->
        <div class="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <router-link to="/about">
                About Us
              </router-link>
            </li>
            <li>
              <router-link to="/services/student-welfare">
                Services
              </router-link>
            </li>
            <li>
              <router-link to="/services/health-wellness">
                Health & Wellness
              </router-link>
            </li>
            <li>
              <router-link to="/home/faqs">
                FAQ
              </router-link>
            </li>
            <li>
              <router-link to="/home/contact">
                Contact
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Services -->
        <div class="footer-links">
          <h4>Services</h4>
          <ul>
            <li>
              <router-link to="/services/student-welfare">
                Guidance & Counseling
              </router-link>
            </li>
            <li>
              <router-link to="/services/career">
                Career Placement
              </router-link>
            </li>
            <li>
              <router-link to="/services/student-development">
                Student Organizations
              </router-link>
            </li>
            <li>
              <router-link to="/services/lost-found">
                Lost & Found
              </router-link>
            </li>
            <li>
              <router-link to="/services/records">
                Student Records
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Contact -->
        <div class="footer-contact">
          <h4>Contact Info</h4>
          <p>
            <i class="fas fa-map-marker-alt" />
            Northeastern College, Santiago City
          </p>
          <p>
            <i class="fas fa-phone-alt" />
            (078) 123-4567
          </p>
          <p>
            <i class="fas fa-envelope" />
            osas@nc.edu.ph
          </p>
        </div>
      </div>

      <!-- Copyright -->
      <div class="footer-bottom">
        <p class="powered-by">
          <img
            src="@/assets/images/logo/CIT-logo.png"
            alt="CIT-logo"
            class="cit-logo"
          >
          <span>Powered by NC CIT Department</span>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'LandingFooter',
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.landing-footer {
  background: linear-gradient(135deg, #0f172a, #1e293b);
  padding: 4rem 0 0;
}

.footer-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2.5rem;
  padding-bottom: 3rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-brand .brand-logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.footer-brand .brand-logo i {
  font-size: 1.5rem;
  color: #10b981;
}

.footer-brand .brand-logo span {
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
}

.footer-brand p {
  color: #94a3b8;
  font-size: 0.9rem;
  line-height: 1.7;
  margin-bottom: 1.5rem;
}

.social-links {
  display: flex;
  gap: 0.75rem;
}

.social-links a {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: #fff;
  transition: all 0.3s;
}

.social-links a:hover {
  background: #10b981;
  transform: translateY(-3px);
}

.footer-links h4,
.footer-contact h4 {
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 1.25rem;
}

.footer-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links ul li {
  margin-bottom: 0.75rem;
}

.footer-links ul li a {
  color: #94a3b8;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s;
}

.footer-links ul li a:hover {
  color: #10b981;
}

.footer-contact p {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #94a3b8;
  font-size: 0.9rem;
  margin-bottom: 0.75rem;
}

.footer-contact p i {
  width: 16px;
  color: #10b981;
}

.footer-bottom {
  padding: 1.5rem 0;
  text-align: center;
}

.footer-bottom p {
  color: #64748b;
  font-size: 0.875rem;
}

.powered-by {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  color: #cbd5e1;
  font-weight: 600;
}

.powered-by .cit-logo {
  width: 22px;
  height: 22px;
  object-fit: contain;
}

@media (min-width: 768px) {
  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .footer-grid {
    grid-template-columns: 2fr 1fr 1fr 1fr;
  }
}
</style>
